import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Storage } from '@ionic/storage';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Client } from '../entities/client';
import { ClientStorage } from '../entities/clientStorage';
import { Router } from '@angular/router';
import { AnonService } from './anon.service';
import { environment } from '../../environments/environment';
import { SessionService } from '../services/session.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  usertokens: string;
  token: string;
  user: string;
  client: Client;
  clientStorage: ClientStorage;
  authenticationState = new BehaviorSubject(false);
  WSIdentityUrl: string;

  constructor(
    private storage: Storage,
    private helper: JwtHelperService,
    private router: Router,

    private loginServices: AnonService<Client>,
    private sessionServices: SessionService
  ) {
    this.WSIdentityUrl = environment.WSIdentityUrl;
  }

  ActualizarToken(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.storage.get('client').then((client) => {
        if (client) {
          this.clientStorage = client;
          // //Se valida la version del almacenamiento.
          // if (this.clientStorage.clientVersion != environment.versioninterna) {
          //   //si no tiene token se redirecciona al login. ?????                    
          //   this.sessionServices.ForceLogout().then(salida => {              
          //   });
          //   reject(''); 
          // }
          this.token = this.clientStorage.Token;
          this.client = this.clientStorage.RClient;
          let isExpired = false;
          if (this.token == '000000000000000000000') {
            isExpired = true;
          } else {
            const expirationDate = this.helper.getTokenExpirationDate(
              this.token
            );
            isExpired = this.helper.isTokenExpired(this.token);
          }

          if (isExpired) {
            //Se tramita el token si tiene AuthID (Google y Facebook)
            if (
              this.clientStorage.RClient.LoginType == 2 ||
              this.clientStorage.RClient.LoginType == 3
            ) {
              const path =
                this.WSIdentityUrl +
                'api/Login/LoginByAuthID?AuthId=' +
                this.clientStorage.RClient.AuthID;
              this.loginServices.MethodGetTokenAsync(path).then((task) => {
                const clt = task['Result'];
                const isError = task['isError'];
                if (isError === true) {
                  //Deberia ir una alerta, de "No hay comunicacion con servidor y no se puede continuar"
                }
                if (clt != null) {
                  this.clientStorage.Token = clt['Token'];
                  this.token = clt['Token'];
                  this.storage.set('client', this.clientStorage);
                  // this.router.navigate(['ofertahoteles']);

                  resolve(this.clientStorage);
                }
              });
            } else if (
              this.clientStorage.RClient.LoginType == 4 ||
              this.clientStorage.RClient.LoginType == 1
            ) {
              const path = this.WSIdentityUrl + 'api/Login/AuthenticateUser';

              this.loginServices
                .MethodPostTokenAsync(this.client, path)
                .then((task) => {
                  const clt = task['Result'];
                  const isError = task['isError'];
                  if (isError === true) {
                    //Deberia ir una alerta, de "No hay comunicacion con servidor y no se puede continuar"
                  }
                  if (clt != null) {
                    //Si la contraseña o algun dato cambió, se debe cerrar y volver a iniciar sesion
                    this.clientStorage.Token = clt['Token'];
                    this.token = clt['Token'];
                    this.storage.set('client', this.clientStorage);

                    resolve(this.clientStorage);
                  }
                });
            }
          } else {
            resolve(this.clientStorage);
          }
        } else {
          //si no tiene token se redirecciona al login. ?????
          reject('');
          this.router.navigate(['/home', {}]);
        }
      });
    });
  }
}
